import React from "react";
import { Navbar, Hero } from "../../Components";
import About from "../../Components/About/About";

const Homepage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
    </div>
  );
};

export default Homepage;
